/**
 * Suppliers waiting on an answer, across every supplier.
 *
 * The rest of this screen is opened supplier by supplier, so a question from
 * one nobody happens to pick would sit unread. This is the one list that comes
 * to the operator instead. Nothing waiting renders nothing at all: an empty
 * "no messages" card at the top of the page every day is a card people learn
 * to stop reading.
 */
define('portalWaitingView',[
  'module',
  'marionette',
  'underscore',
  'jquery',
  'dateUtils',
  'template!portalWaitingTpl'
], function (
  Module,
  Marionette,
  _,
  $,
  DateConverter,
  waitingTpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: waitingTpl,
    className: 'portal-waiting-view',

    events: {
      'click .js-open': 'onOpen'
    },

    initialize: function (options) {
      this.orders = options.orders || [];
    },

    serializeData: function () {
      return {
        orders: _.map(this.orders, function (order) {
          return {
            secId: order.secId,
            purchaseOrderId: order.purchaseOrderId,
            supplierCode: order.supplierCode,
            productCode: order.productCode,
            productName: order.productName,
            unreadMessages: order.unreadMessages || 0,
            delivery: order.deliveryDate ? DateConverter.toDateFormatString(order.deliveryDate) : null
          };
        })
      };
    },

    onOpen: function (event) {
      var secId = $(event.currentTarget).attr('data-secid');
      var order = _.find(this.orders, function (candidate) {
        return candidate.secId === secId;
      });
      if (order) {
        this.trigger('conversation', order);
      }
    }
  });
});

